import { render, staticRenderFns } from "./ModalPathologistAssignment.vue?vue&type=template&id=75a89698&"
import script from "./ModalPathologistAssignment.vue?vue&type=script&lang=js&"
export * from "./ModalPathologistAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ModalPathologistAssignment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports